import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import Container from 'react-bootstrap/Container';
import "./Project.css";
import iNotes from "./Images/iNotes.png";
import Uconv from "./Images/unit_converter.png";
import Button from 'react-bootstrap/Button';
import {BsBoxArrowUpRight} from "react-icons/bs";

function Project(){
    return(
        <section id="projects">
            <Container fluid='md'>
                <div className="project-head"><h1>Projects</h1></div>
            <Carousel style={{minHeight:"75vh"}}>
                <Carousel.Item className="car-item" interval={2500}>
                  <img
                    className=" project-image"
                    src={iNotes}
                    alt="iNotes"
                  />
                    <h2 className="car-title">iNotes</h2>
                    <p className="car-content">A Web application designed to store all your notes. The technologies used are React, Node.js, Express.js and MongoDB.</p>
                    <Button variant="outline-light" className="car-button" href="https://inotes10.netlify.app/" target="_blank">
                      Visit
                      <BsBoxArrowUpRight className="arrow-icon" />
                    </Button>
                </Carousel.Item>
                <Carousel.Item className="car-item" interval={2500}>
                  <img
                    className=" project-image"
                    src={Uconv}
                    alt="Unit Converter"
                  />
                    <h2 className="car-title">Unit Converter</h2>
                    <p className="car-content">A Web application designed to convert various units. The technologies used are Node.js, Express.js, jQuery and EJS.</p>
                    <Button variant="outline-light" className="car-button" href="https://unit-converter-lem6.onrender.com/home" target="_blank">
                      Visit
                      <BsBoxArrowUpRight className="arrow-icon" />
                    </Button>
                </Carousel.Item>
            </Carousel>
          </Container>
        </section>
    );
}

export default Project;